import type { HomeConfig } from '@/components/subject/configs.ts';

const homeConfig: HomeConfig = {
  experiments: [

  ],
  mindMaps: [
    {
      title: '整除性',
      description: '整除性是数论中的重要概念，描述了一个数是否能被另一个数整除。理解整除性有助于更好地应用数论进行分析和求解。',
      img: '/homePage/nt.png',
      path: '/mindmap/question/173',
    },
  ],
  thinking: [
  ],
};

export { homeConfig };
